module.exports = __webpack_public_path__ + "media/images/members/laura_carbajo_lago-e40e2a5a6c9a8a022a6742ba1d59bfac.jpg";